define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "../../molecules/AccordionProvider"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _AccordionProvider) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  var _excluded = ["children", "id"];

  var AccordionRegion = function AccordionRegion(_ref) {
    var children = _ref.children,
        id = _ref.id,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);

    var _useAccordionContext = (0, _AccordionProvider.useAccordionContext)(),
        currentKey = _useAccordionContext.currentKey;

    return currentKey === id ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      tabIndex: "0",
      role: "region",
      id: id + "-region",
      "aria-labelledby": id
    }, rest), children) : null;
  };

  var _default = AccordionRegion;
  _exports.default = _default;
});